import { OwnerView as Regiepult } from './OwnerView';
import { PlayerView } from './PlayerView';
import type { Me } from '../lib/types';

/**
 * Welche Ansicht jemand bekommt, entscheidet die Rolle.
 *
 * Die eigentliche Entscheidung trifft ohnehin der Server: Er schickt an die Besitzerin eine andere
 * Fassung als an einen Spieler. Hier wird nur ausgewählt, welche Oberfläche dazu passt.
 */
export function OwnerView({
  lobbyId,
  me,
  onLogout,
}: {
  lobbyId: string;
  me: Me;
  onLogout: () => void;
}) {
  return me.role === 'LOBBY_OWNER' || me.role === 'SUPER_ADMIN' || me.role === 'TEST_ADMIN' ? (
    <Regiepult lobbyId={lobbyId} onLogout={onLogout} />
  ) : (
    <PlayerView lobbyId={lobbyId} onLogout={onLogout} />
  );
}
